import React, {
  useState,
  useReducer,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Lookup,
  RequiredRule,
  Item,
  Paging,
  Pager,
  ColumnFixing,
  Export,
  ColumnChooser,
  Toolbar,
  FilterRow,
  HeaderFilter,
  SearchPanel,
  Editing,
  GroupPanel,
  Grouping,
  MasterDetail,
  Button,
} from "devextreme-react/data-grid";

import { Toast } from "devextreme-react/toast";
import * as action from "../../actions/sa3";
import * as actions from "../../actions/common";
import sa3Reducer from "../../reducers/sa3";
import { set, get, getTypeOfFile, onDownloadFile ,setGridUserPrefs, setGridWidthPrefs, applyUserPref, saveUserPref} from "../../common/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import { postUserLog } from "../../actions/common";
import DateBox from "devextreme-react/date-box";
import RadioGroup from "devextreme-react/radio-group";
import SA3 from "./SA3";
import SA3GridDetail from "./SA3GridDetail";
import CustomButton from "../common/CustomButton";
import { isEmpty, isEqual } from "lodash";
import { postLogForGridOperations } from "./utils";
const initialRailState = {
  safety: "",
  railActions: "",
  railEscalated: "",
  railNotes: "",
  railStartDate: "",
  railDueDate: "",
  compDate: "",
  railPriority: "",
  railStatus: "",
  railOwner: "",
  topThree: "",
  railPdca: "",
  railPlan: "",
  railDo: "",
  railCheck: "",
  railAct: "",
  railImageName: "",
  userPrefSettings: null 
};

const initialState = {
  sa3GridData: [],
  peopleList: null,
  tiersList: null,
  approvers: [],
  reasonCodes: [],
};

const SA3Grid = (props: any) => {
  const isLightMode = useSelector((state: any) => state.theme.lightMode);
  let {
    siteId,
    tierId,
    data,
    siteUid,
    activeItem,
    template,
    isEditable,
    tab,
    FromDGsa3PopUpMgr,
    navigationOn,
    siteDate,
  } = props;

  const [state, dispatch] = useReducer(sa3Reducer, initialState);
  const [a3EditPopUpMgr, setA3EditPopUpMgr] = useState<boolean>(false);
  const { sa3GridData, peopleList, approvers, reasonCodes, tiersList ,userPrefSettings  } = state;
  const stat = ["Not Started", "In Progress", "Completed"];
  const priority = ["High", "Medium", "Low"];
  const [sqdicp, setSqdicp] = useState(
    template.map((d: any) => {
      return d.title;
    })
  );
  const widgetId = 'sa3Widget';
  const GRID_COLS = JSON.stringify([ "A3ID","areaToSolve","problemToSolve","coachName","processOwnerName","startDate","dueDate","strategicObjective","problemStatement","status","andon"]);
  const loggedinUser = get("hid");

  const a3DataGridRef = useRef<any>(null);
  const [isPopupVisible, setIsPopupVisibility] = useState<boolean>(false);
  const [isFilePopupVisible, setIsFilePopupVisibility] =
    useState<boolean>(false);
  const [railViewInfo, setPopupData] = useState({ initialRailState });
  const [selectedFiles, setSlectedFiles] = useState(null);
  const [onFirstLoad, setOnFirstLoad] = useState(true);
  const [showExportForm, setShowExportForm] = useState(false);
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [exportFilter, setExportFilter] = useState(0);
  const [popUpImages, setPopUpImages] = useState([]);
  const setDeleted = (d: any) => {
    delList = d;
  };
  const [showRPS, setShowRPS] = useState(false);
  const [a3PopUpMgr, setA3PopUpMgr] = useState(false);
  const [a3IDRail, setA3IDRail] = useState(0);
  const [rpsIdAction, setRpsIdAction] = useState(1);
  const [listA3ID, setListA3ID] = useState<any>([]);
  const basePath = window.location.origin;
  const [loading, setLoading] = useState(false);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [toastConfig, setToastConfig] = useState<any>({
    isVisible: false,
    type: "info",
    message: "",
  });
  let delList: any = [];
  // let rpsConfig = { ...GRID_CONFIG.RPS_GRID_CONFIG };

  // const handleClick = () => {
  //     setLoading(true);
  //     // Perform your asynchronous operation here, e.g., API request
  //     // Once the operation is complete, set loading to false
  //     setTimeout(() => {
  //         setLoading(false);
  //     }, 2000);
  // };

  useEffect(() => {
    let siteInfo = siteUid ? `&siteId=${siteUid}` : "";

    action.fetchUsers(dispatch, `tierId=${tierId}` + siteInfo);
    action.getApproverHighestTier(dispatch, siteId);

    if (siteUid) action.fetchTiersList(dispatch, siteUid);
    action.fetchA3GridData(dispatch, tierId + siteInfo);
    //if (siteUid) {
    //    if (rpsConfig.editing.form.items[0].items.indexOf("tierlevel") == -1)
    //        rpsConfig.editing.form.items[0].items.push("tierlevel")
    //}
    //else {
    //    if (rpsConfig.editing.form.items[0].items.indexOf("tierlevel") != -1)
    //        rpsConfig.editing.form.items[0].items.pop("tierlevel")
    //}

    //   if (!isEditable) {
    //       rpsConfig.editing.allowUpdating = false;
    //       rpsConfig.editing.allowAdding = false;
    //       rpsConfig.editing.allowDeleting = false;
    //   } else {
    //       rpsConfig.editing.allowUpdating = true;
    //       rpsConfig.editing.allowAdding = true;
    //       rpsConfig.editing.allowDeleting = true;
    //   }
  }, []);

  //   useEffect(() => {
  //       if (onFirstLoad && sa3GridData.length) {
  //           let data = sa3GridData.filter((val:any) => {
  //               return val.status !== "Completed";
  //           });
  //           dispatch({ type: ACTION_TYPES.FETCH_PERF_GRID, payload: data });
  //           set("railData", data);
  //           setOnFirstLoad(false);
  //       } else {
  //           set("railData", sa3GridData);
  //       }
  //   }, [sa3GridData, onFirstLoad]);

  // const onEditingStart = () => setDeleted([]);
  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  // //const cellRender = (data) => {
  // //    let top3tpl = (data.data && data.data.top3 < 9 && data.data && data.data.top3 > 0) ? <span className="fa-layers fa-fw">
  // //        <i className="fas fa-star fa-2x top3-icon"></i>
  // //        <span className="fa-layers-text fa-inverse top3-txt primary-txt-clr" data-fa-transform="shrink-8 down-3" >{data.data.top3} </span>
  // //    </span > : '';
  // //    return <span>{top3tpl} <span className="w-50">{data.value}</span></span>
  // //}

  // const onContentReady = (e) => {
  //     //rpsDataGrid.current.instance.updateDimensions();

  //     var columnChooserView = e.component.getView("columnChooserView");
  //     if (!columnChooserView._popupContainer) {
  //         columnChooserView._initializePopupContainer();
  //         columnChooserView.render();
  //         columnChooserView._popupContainer.option("position", {
  //             of: e.element,
  //             my: "right top",
  //             at: "right top",
  //             offset: "0 50",
  //         });
  //     }
  // };
  //   const useMethod = () => {
  //     //rpsDataGrid.current.instance.updateDimensions();
  //   };

  //   const lengthyTextCellRender = (data: any) => {
  //     let cellText: any = "";
  //     if (data.text && data.text.length > 100) {
  //       cellText = (
  //         <ShowMoreText
  //           lines={2}
  //           more="Show More"
  //           less="Show Less"
  //           className="content-css"
  //           anchorClass="my-anchor-css-class"
  //           expanded={false}
  //           width={280}
  //           onClick={useMethod}
  //           truncatedEndingComponent={"... "}
  //         >
  //           {data.text}
  //         </ShowMoreText>
  //       );
  //       return (data.text = cellText);
  //     } else {
  //       cellText = data.text;
  //       return (data.text = cellText);
  //     }
  //   };

//Start -User preference
useEffect(() => {
  action.fetchUserPref(
      dispatch,
      `=${props.tierId}&SiteUID=${props.siteId}&widgetID=${widgetId}`
  );
  return () => {
    action.updateUserPref(dispatch, saveUserPref({ widgetId,  siteId :props.siteId, tierId: props.tierId, moduleName: widgetId, loggedinUser, prefSess: 'userPrefSettings', GRID_COLS }));
  };
}, []);

useEffect(() => {
  if (userPrefSettings) set("userPrefSettings", userPrefSettings);
  if (a3DataGridRef && a3DataGridRef.current && a3DataGridRef.current.instance !== null && userPrefSettings && sa3GridData) {
    applyUserPref(a3DataGridRef, userPrefSettings)
}
}, [sa3GridData, peopleList, approvers, reasonCodes, tiersList ,userPrefSettings ])
// End -User preference
  const onRowRemoved = (data: any) => {
    // if (siteUid) {
    //   let getTiersList = get("tiersList");
    //   let tierInfo = getTiersList.find((d: any) => {
    //     if (d.tierlevel === data.data.tierLevel) return d;
    //   });
    //   if (tierInfo) tierId = tierInfo.tierID;
    // }
    action.deleteA3GridData(dispatch, data.data.a3ID, data.data.tierId,navigationOn);
    // action.deleteA3GridData(dispatch, data.data.a3id);
    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "success",
      message: "A3 Item Removed Successfully!!",
    });
    //rpsDataGrid.current.instance.updateDimensions();
  };

  const handlers = {
    //  onRowUpdated: onRowUpdated,
    onRowRemoved: onRowRemoved,
    //onEditingStart: onEditingStart,
  };

  const togglePopup = () => {
    setIsPopupVisibility(!isPopupVisible);
    //rpsDataGrid.current.instance.updateDimensions();
  };

  // const toggleFilePopup = () => {
  //     setIsFilePopupVisibility(!isFilePopupVisible);
  //     //rpsDataGrid.current.instance.updateDimensions();
  // };

  // const toggleFileRcaPopup = () => {
  //     setIsFileRcaPopupVisible(!isFileRcaPopupVisible);
  //     //rpsDataGrid.current.instance.updateDimensions();
  // };

  // function populatePopupData(railData:any) {
  //     togglePopup();
  //     setPopupData({ railViewInfo: railData.row.data });
  //     rpsDataGrid.current.instance.updateDimensions();
  // }
  const populatePopupA3Data = (rpsdata: any) => {
    //  setRpsIdAction(action);
    setA3IDRail(rpsdata.row.data.a3ID);
    setA3EditPopUpMgr(true);
    postUserLog({
      event: "A3 Grid Launch",
      data: {
        action: `A3 Widget launch A3-`+rpsdata.row.data.a3ID,
        module: "Digital Tier",
        section: `${data[activeItem].title}`,
        siteUId: siteId,
        widget: "Strategic A3",
        tierId: tierId,
      },
    });
    action.fetchData(dispatch, rpsdata.row.data.a3ID);
  };
  // const toggleRPSPopup = () => {
  //     setA3EditPopUpMgr(!isPopupVisible);
  //     rpsDataGrid.current.instance.updateDimensions();
  // };

  // useEffect(() => {
  //     set("tiersList", state.tiersList);
  // }, [state.tiersList]);
 
  const handlePropertyChange = (e: any) => {
    //if (e.name === "changedProperty") {
    //rpsDataGrid.current.instance.updateDimensions();
   
    postLogForGridOperations(
      a3DataGridRef,
      e,
      siteId,
      tierId,
      "A3 Grid",
      null,
      data[activeItem].title
    );
    if (e.value == "Completed") {
      let siteInfo = siteUid ? `&siteId=${siteUid}` : "";
      action.fetchA3GridData(dispatch, (tierId || "") + siteInfo);
    } else if (e.value == null && e.previousValue == "Completed") {
      setOnFirstLoad(true);
    }
    setGridWidthPrefs(e, widgetId);
    // }
  };

  const isRailReady = () => {
    if (siteUid && state.peopleList && state.tiersList) return true;
    else if (state.peopleList) return true;
    return false;
  };

  const exportData = (e: any) => {
    setShowExportForm(!showExportForm);
    getFilteredAndSortedData();
    e.cancel = true;
  };

  const onExportingA3 = (e: any) => {
    setLoading(true);
    actions.exportData("A3/exportA3Data", "Honeywell A3", {
      lstID:
        (listA3ID.listA3ID && listA3ID.listA3ID.length) > 0
          ? listA3ID.listA3ID
          : null,
      siteId: siteId,
      tierId: tierId,
      widgetId: "",
      isAll: exportFilter == 2 ? false : true,
      startDate: moment(sDate).format("DD/MM/YYYY"),
      endDate: moment(eDate).format("DD/MM/YYYY"),
      section:data[activeItem].title
    });

    //.then((res) => {  res.setLoading(false);})
    e.cancel = true;

    // Perform your asynchronous operation here, e.g., API request
    // Once the operation is complete, set loading to false
    if ((tierId = "602"))
      setTimeout(() => {
        setLoading(false);
      }, 9000);
    else
      setTimeout(() => {
        setLoading(false);
      }, 5000);
  };

  const renderAndOn = (cell: any) => {
    return (
      <div style={{ textAlign: "center", width: "20px", height: "20px" }}>
        {" "}
        <span
          style={{ background: cell.value, textAlign: "center" }}
          className="rpsAndonDot"
        ></span>
      </div>
    );
  };

  const onValueChanged = () => {
    postUserLog({
      event: "A3 Grid Launch",
      data: {
        action: `A3 Widget launch`,
        module: "Digital Tier",
        section: `${data[activeItem].title}`,
        siteUId: siteId,
        widget: "Strategic A3",
        tierId: tierId,
      },
    });
    setA3IDRail(0);
    setA3PopUpMgr(true);
  };

  useEffect(() => {
    if (a3PopUpMgr == false) {
      let siteInfo = siteUid ? `&siteId=${siteUid}` : "";
      if (siteUid) action.fetchTiersList(dispatch, siteUid);
      action.fetchA3GridData(dispatch, tierId + siteInfo);
    }
  }, [a3PopUpMgr, a3EditPopUpMgr, FromDGsa3PopUpMgr]);

  const getFilteredAndSortedData = useCallback(() => {
    const grid = a3DataGridRef.current.instance;
    const filterExpr = grid.getCombinedFilter(true);
    const dataSource = grid.getDataSource();
    const loadOptions = dataSource.loadOptions();
    dataSource
      .store()
      .load({
        filter: filterExpr,
        sort: loadOptions.sort,
        group: loadOptions.group,
      })
      .then((result: any) => {
        if (filterExpr != undefined) {
          if (filterExpr.length >= 3)
            setListA3ID({
              listA3ID: result.map((x: any) => {
                return x.a3ID;
              }),
            });
        } else {
          setListA3ID({ listA3ID: null });
        }
      });
  }, [a3DataGridRef]);
  // const filterValue = [
  //     ["status", "=", "Open"],
  //     "and",
  //     ["areaToSolve", "=", `${data[activeItem].title}`],
  // ];

  // const calculateFilterExpression = (
  //     value:any,
  //     selectedFilterOperations:any,
  //     target:any
  // ) => {
  //     const column = this;

  //     if (target === "headerFilter") {
  //         return [[getOrderDay, "<", value], "or", [getOrderDay, ">", value]];
  //     }
  //     return defaultCalculateFilterExpression(
  //         value,
  //         selectedFilterOperations,
  //         target
  //     );
  // };

  // const orderHeaderFilter = (data:any) => {
  //     data.dataSource.postProcess = (results:any) => {
  //         return results;
  //     };
  // };
  // function getOrderDay(rowData:any) {
  //     return new Date(rowData.startDate);
  // }
  return (
    <>
      <div className="gem-fltr-adj " style={{ right: "297px" }}>
        <div className="dx-field-value-static">
          {isEditable ? (
            <button
              style={{ padding: "11px 14px", cursor: "pointer" }}
              className="dx-button-mode-contained"
              id="link4"
              onClick={onValueChanged}
            >
              <i className="fas fa-plus"></i>
            </button>
          ) : null}
        </div>
      </div>

      {isRailReady() && (
        <DataGrid
          ref={a3DataGridRef}
          dataSource={sa3GridData}
          onExporting={exportData}
          showBorders={true}
          allowColumnReordering={true}
          onContentReady={e => setGridUserPrefs(e, widgetId)}
          onColumnsChange={e => setGridWidthPrefs(e, widgetId)}
          // onContentReady={onContentReady}
           repaintChangesOnly={true}
          wordWrapEnabled={true}
          onOptionChanged={handlePropertyChange}
          allowColumnResizing={true}
          columnAutoWidth={true}
          //  defaultFilterValue={filterValue}
          remoteOperations={true}
          //  onEditorPreparing={onEditorPreparing}
          width="100%"
          height="100%"
          // {...rpsConfig}
          {...handlers}
        >
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />

          <ColumnFixing enabled={true} />
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" allowSearch={true} />
          <SearchPanel
            visible={true}
            onTextChange={(e) => {
              if (!isEmpty(e))
                postUserLog({
                  event: "A3 Grid Search",
                  data: {
                    action: `${e} searched in A3 Grid`,
                    module: "Digital Tier",
                    section: `${data[activeItem].title}`,
                    siteUId: siteId,
                    widget: "Strategic A3",
                    tierId: tierId,
                  },
                });
            }}
          />
          <Editing
            mode="row"
            allowUpdating={isEditable}
            allowDeleting={isEditable}
            allowAdding={isEditable}
            useIcons={true}
          />
          <Toolbar>
            <Item visible={true} name="refreshButton" />
            <Item location="before">
              <RadioGroup
                items={[
                  { id: 0, text: "All" },
                  { id: 2, text: "Date range" },
                ]}
                value={exportFilter}
                valueExpr="id"
                displayExpr="text"
                onValueChanged={(e) => setExportFilter(e.value)}
                layout="horizontal"
                visible={showExportForm ? true : false}
              />
            </Item>

            <Item location="before">
              <DateBox
                label="Start Date*"
                labelMode="floating"
                visible={exportFilter == 2 && showExportForm ? true : false}
                value={sDate}
                onValueChanged={(e) => setSDate(e.value)}
                useMaskBehavior={true}
                height={30}
                type="date"
              />
            </Item>
            <Item location="before">
              <DateBox
                label="End Date*"
                labelMode="floating"
                visible={exportFilter == 2 && showExportForm ? true : false}
                value={eDate}
                onValueChanged={(e) => setEDate(e.value)}
                height={30}
                type="date"
                useMaskBehavior={true}
              />
            </Item>
            <Item location="before">
              {showExportForm ? (
                <div className="cbtn d-flex justify-space-between align-items-center">
                  <CustomButton
                    onClick={(e: any) => onExportingA3(e)}
                    className="btn secondary-btn"
                    loading={showExportForm ? loading : false}
                  >
                    {loading ? "Loading..." : "Export"}
                  </CustomButton>
                </div>
              ) : (
                <></>
              )}
            </Item>

            <Item location="before">
              {showExportForm ? (
                <div className="cbtn d-flex justify-space-between align-items-center">
                  <button onClick={exportData} className="btn primary-btn">
                    Cancel
                  </button>
                </div>
              ) : (
                <></>
              )}
            </Item>
            <Item location="after" name="exportButton" />
            <Item name="columnChooserButton" />
            <Item name="searchPanel" visible={true} />
          </Toolbar>
          <FilterRow visible={true} />
          {/* <FilterPanel visible={true} /> */}
          <GroupPanel visible={true} />
          <HeaderFilter visible={true} />
          <Grouping autoExpandAll={false} />
          {
            //// <RemoteOperations
            //  filtering={true}
            //   paging={true}
            //     sorting={true}
            //      summary={true}
            //       grouping={true}
            //groupPaging={true}
            //   />
          }
          <Column
            dataField="a3ID"
            caption="A3ID"
            dataType="number"
            allowEditing={false}
            width={90}
            visible={true}
          ></Column>
          {tab && (
            <Column
              dataField="areaToSolve"
              caption="Area To Solve"
              dataType="string"
              visible={true}
              width={100}
              filterValues={[tab]}
              allowHeaderFiltering={true}
              allowFiltering={false}
            >
              <Lookup dataSource={sqdicp} />
            </Column>
          )}
           <Column
            dataField="problemToSolve"
            caption="Problem To Solve"
            dataType="string"
            allowEditing={false}
            visible={true}
            showInColumnChooser={true}
          >
          </Column>
          <Column
            dataField="processOwnerName"
            caption="Process Owner"
            dataType="string"
            width={150}
            visible={true}
            allowHeaderFiltering={true}
            allowFiltering={false}
          ></Column>
          <Column
            dataField="coachName"
            caption="Coach"
            dataType="string"
            width={150}
            visible={true}
            allowHeaderFiltering={true}
            allowFiltering={false}
          ></Column>
          {/* <Column
            dataField="tierlevel"
            caption="Tier Level"
            dataType="number"
            allowEditing={false}
          ></Column>
          <Column
            dataField="tiername"
            caption="Tier Name"
            dataType="string"
            allowEditing={false}
          ></Column> */}
          <Column
            dataField="startDate"
            caption="Start Date"
            dataType="date"
            visible={true}
            width={150}
            editorOptions={{
              useMaskBehavior: false,
              displayFormat: "MM/dd/yyyy",
            }}
            allowFiltering={false}
            allowHeaderFiltering={true}
            format="MM/dd/yyyy"
            //dateSerializationFormat="MM/dd/yyyy"
            // calculateFilterExpression={(e) => { calculateFilterExpression }}
          >
            {
              //   <HeaderFilter dataSource={orderHeaderFilter} />
            }
            <RequiredRule />
          </Column>
          <Column
            dataField="dueDate"
            caption="Due Date"
            dataType="date"
            visible={true}
            width={150}
            editorOptions={{
              useMaskBehavior: false,
              displayFormat: "MM/dd/yyyy",
            }}
            allowHeaderFiltering={true}
            allowFiltering={false}
            format="MM/dd/yyyy"
            // dateSerializationFormat="MM/dd/yyyy"
          >
            <RequiredRule />
          </Column>
          {/* <Column
            dataField="completedDate"
            caption="Completed Date"
            dataType="date"
            width={110}
            visible={false}
            editorOptions={{ useMaskBehavior: true }}
          ></Column> */}
          <Column
            dataField="strategicObjective"
            caption="Strategic Objective"
            dataType="string"
            allowEditing={false}
            visible={true}
            showInColumnChooser={true}
          />
           <Column
            dataField="problemStatement"
            caption="Problem Statement"
            dataType="string"
            allowEditing={false}
            visible={true}
            showInColumnChooser={true}
          />
           <Column
            dataField="status"
            caption="Status"
            dataType="string"
            allowEditing={false}
            visible={true}
            showInColumnChooser={true}
          />
         
          <Column
            dataField="andon"
            caption="Andon"
            width={40}
            cellRender={renderAndOn}
            allowFiltering={false}
          />
          <Column
            fixed={true}
            type="buttons"
            //   /  id="popup"
            minWidth={100}
            showInColumnChooser={false}
          >
            {/* <Button
              name="view"
              hint="View Details"
              icon="info"
              onClick={(e) => {
                populatePopupRPSData(e, "info");
              }}
            ></Button> */}
            <Button
              name="edit"
              onClick={populatePopupA3Data}
              icon="edit"
            ></Button>
            <Button name="delete" icon="trash"></Button>
          </Column>
          <MasterDetail enabled={true}  component={SA3GridDetail} />
        </DataGrid>
      )}

      {a3EditPopUpMgr && (
        <SA3
          a3ID={a3IDRail}
          tierId={tierId}
          siteId={siteId}
          activeItem={activeItem}
          data={template}
          closeShift={(d: any) => setA3EditPopUpMgr(d)}
          isRail={false}
          siteDate={siteDate}
        />
      )}
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
      {a3PopUpMgr && (
        <SA3
          a3ID={a3IDRail}
          tierId={tierId}
          siteId={siteId}
          activeItem={activeItem}
          data={template}
          closeShift={(d: any) => setA3PopUpMgr(d)}
          isRail={false}
          siteDate={siteDate}
        />
      )}
    </>
  );
};
export default SA3Grid;
